import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Facebook, label: 'Facebook', url: 'https://www.facebook.com/share/17zGGVWfeF/' },
    { icon: Instagram, label: 'Instagram', url: 'https://www.instagram.com/saucedogzaz?igsh=cGd1NTQxMWkzaXh2' }
  ];

  return (
    <footer className="bg-black border-t border-gray-800 relative overflow-hidden">
      {/* Gradient accents */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-cyan-400 to-orange-500"></div>
      
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold mb-4">
              <span className="text-white">SAUCE</span>
              <span className="text-orange-500"> DOGZ</span>
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Launching gourmet hot dogs into orbit since 2025. Your neighborhood's favorite hot dog cart.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-gray-400 hover:text-orange-500 transition-colors duration-200">
                  About Us
                </a>
              </li>
              <li>
                <a href="#menu" className="text-gray-400 hover:text-orange-500 transition-colors duration-200">
                  Menu
                </a>
              </li>
              <li>
                <a href="#location" className="text-gray-400 hover:text-orange-500 transition-colors duration-200">
                  Location
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-orange-500 transition-colors duration-200">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Connect With Us</h4>
            <div className="space-y-3 mb-6">
              <a href="tel:602-730-4994" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                <Phone className="w-5 h-5" />
                <span>(602) 730-4994</span>
              </a>
              <a href="mailto:saucedogz@yahoo.com" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                <Mail className="w-5 h-5" />
                <span>saucedogz@yahoo.com</span>
              </a>
            </div>
            
            <div className="flex gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.url}
                    aria-label={social.label}
                    className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-orange-500 hover:text-white transition-all duration-300 hover:scale-110"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-500">
            &copy; {currentYear} Sauce Dogz. All rights reserved. Made with{' '}
            <span className="text-orange-500">♥</span> and hot dogs.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;